import React from 'react';
import './bachatkhata.css';
import savingsImage from '../assets/bachat1.jpg';

const BachatKhata = () => {
  return (
    <div className="bachatkhata-container">
      <img src={savingsImage} alt="Savings Account" className="top-image" />
      <h1>बचत खाते (Savings Account)</h1>
      <p>
        सुरक्षित भविष्याकरिता बचत ही अनिवार्य आहे यात कोणाचेच दुमत नाही. तुम्हालाही बचतीची सवय लागावी,
        तुमचीही बचत व्हावी, तुम्हालाही आर्थिक स्थैर्य मिळावे या हेतूने संस्थेमध्ये 'बचत खाते' उपलब्ध आहे.
        या खात्यावर जास्तीत जास्त व्याज दिले जाते व त्या बरोबरच ग्राहकांना पासबुक, NEFT / RTGS / IMPS
        इ. सुविधा पुरविल्या जातात.
      </p>

      <ul className="features">
        <li>पासबुक सुविधा</li>
        <li>आरटीजीएस सुविधा उपलब्ध</li>
      </ul>
    </div>
  );
};

export default BachatKhata;
